// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"e2f2741d","327":"bd50eae3","453":"94b93b3c","987":"fe22965d"}[chunkId] + ".chunk.js";
};